import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/AppLayout.vue'),
    children: [
      { path: 'polymers', component: () => import('@/views/PolymersView.vue') },
      { path: 'polymers/:id', component: () => import('@/views/PolymerDetailView.vue') },
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
      },
      {
        path: 'profiles',
        name: 'profiles',
        component: () => import('@/views/ProfilesListView.vue'),
      },
      {
        path: 'profiles/new',
        name: 'profile-new',
        component: () => import('@/views/ProfileFormView.vue'),
      },
      {
        path: 'profiles/:id',
        name: 'profile-detail',
        component: () => import('@/views/ProfileFormView.vue'),
      },
      {
        path: 'devices',
        name: 'devices',
        component: () => import('@/views/DevicesListView.vue'),
      },
      {
        path: 'devices/:id',
        name: 'device-detail',
        component: () => import('@/views/DeviceDetailView.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const auth = useAuthStore()
  if (to.meta.public) {
    return true
  }
  if (!auth.isAuthenticated) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  return true
})

export default router
